var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "itinerary mb-3", class: { active: _vm.visible } },
    [
      _c("div", { staticClass: "itinerarySummary" }, [
        _c("div", { staticClass: "itinerarySummary__times" }, [
          _c(
            "div",
            {
              staticClass:
                "itinerarySummary__time align-self-start itinerarySummary__time--start",
            },
            [
              _c("span", [
                _vm._v(
                  "\n                  " +
                    _vm._s(_vm.timeStart) +
                    "\n                  "
                ),
                _c("small", [_vm._v(_vm._s(_vm.dateStart))]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "itinerarySummary__number align-self-start mt-2" },
            [
              _vm._v("\n        " + _vm._s(_vm.duration) + "\n        "),
              _c(
                "div",
                { staticClass: "trip-breaks" },
                [
                  _vm._l(_vm.tripBreaks + 1, function (n) {
                    return [_c("div")]
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c("small", [
                _vm._v(_vm._s(_vm.trainNumber)),
                _vm.change ? _c("br") : _vm._e(),
                _vm._v(_vm._s(_vm.change)),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "itinerarySummary__time align-self-start itinerarySummary__time--end",
            },
            [
              _c("span", [
                _vm._v(
                  "\n                  " +
                    _vm._s(_vm.timeEnd) +
                    "\n                  "
                ),
                _c("small", [_vm._v(_vm._s(_vm.dateEnd))]),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "itinerarySummary__button" },
          [
            _vm._t("buy-button-slot", function () {
              return [_vm._v("def")]
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm._t("warning"),
      _vm._v(" "),
      _vm.details
        ? _c("div", [
            _vm.visible
              ? _c(
                  "button",
                  {
                    staticClass: "itineraryMore itineraryMore--hide mx-auto",
                    attrs: { "aria-expanded": "true" },
                    on: { click: () => _vm.hide() },
                  },
                  [_vm._v("zwiń szczegóły")]
                )
              : _c(
                  "button",
                  {
                    staticClass: "itineraryMore mx-auto",
                    attrs: { "aria-expanded": "false" },
                    on: { click: () => _vm.show() },
                  },
                  [_vm._v("rozwiń szczegóły")]
                ),
            _vm._v(" "),
            _c(
              "ul",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.visible,
                    expression: "visible",
                  },
                ],
                staticClass: "itineraryTimeline",
              },
              [
                _vm._t("timeline", function () {
                  return [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        staticClass:
                          "itineraryTimeline__item itineraryTimeline__item--services",
                      },
                      [
                        _vm._m(1),
                        _vm._v(" "),
                        _vm.extraDetailsVisible
                          ? _c(
                              "button",
                              {
                                staticClass: "extra-details-btn hidden focus",
                                attrs: {
                                  "aria-expanded": "true",
                                  "aria-label": "zwiń szczegóły",
                                },
                                on: { click: () => _vm.hideExtraDetails() },
                              },
                              [
                                _c("i", {
                                  staticClass: "bi bi-dash-circle-fill focus",
                                }),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.extraDetailsVisible
                          ? _c(
                              "button",
                              {
                                staticClass: "extra-details-btn hidden focus",
                                attrs: {
                                  "aria-expanded": "false",
                                  "aria-label": "rozwiń szczegóły",
                                },
                                on: { click: () => _vm.showExtraDetails() },
                              },
                              [
                                _c("i", {
                                  staticClass: "bi bi-plus-circle-fill",
                                }),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.extraDetailsVisible
                      ? [
                          _vm._m(2),
                          _vm._v(" "),
                          _vm._m(3),
                          _vm._v(" "),
                          _vm._m(4),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._m(5),
                    _vm._v(" "),
                    _vm._m(6),
                    _vm._v(" "),
                    _vm._m(7),
                    _vm._v(" "),
                    _vm._m(8),
                  ]
                }),
              ],
              2
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "li",
      { staticClass: "itineraryTimeline__item itineraryTimeline__item--start" },
      [
        _c("span", [
          _vm._v("\n                  6:48\n                  "),
          _c("small", [_vm._v("3 lut")]),
        ]),
        _vm._v("\n        Warszawa Centralna\n        "),
        _c("small", [_vm._v("peron III, tor 4")]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "itineraryTimeline__icons" }, [
      _c("img", {
        staticClass: "img-fluid",
        attrs: { src: "/images/itinerary/ico0.png", alt: "" },
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "img-fluid",
        attrs: { src: "/images/itinerary/ico1.png", alt: "" },
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "img-fluid",
        attrs: { src: "/images/itinerary/ico2.png", alt: "" },
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "img-fluid",
        attrs: { src: "/images/itinerary/ico3.png", alt: "" },
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "img-fluid",
        attrs: { src: "/images/itinerary/ico4.png", alt: "" },
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "img-fluid",
        attrs: { src: "/images/itinerary/ico5.png", alt: "" },
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "img-fluid",
        attrs: { src: "/images/itinerary/ico6.png", alt: "" },
      }),
      _vm._v(" "),
      _c("img", {
        staticClass: "img-fluid",
        attrs: { src: "/images/itinerary/ico7.png", alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "li",
      {
        staticClass: "itineraryTimeline__item itineraryTimeline__item--station",
      },
      [
        _c("span", [_c("small", [_vm._v("12:04")])]),
        _vm._v(" "),
        _c("small", [_vm._v("Warszawa Wschodnia")]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "li",
      {
        staticClass: "itineraryTimeline__item itineraryTimeline__item--station",
      },
      [
        _c("span", [_c("small", [_vm._v("12:04")])]),
        _vm._v(" "),
        _c("small", [_vm._v("Warszawa Wschodnia")]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "li",
      {
        staticClass: "itineraryTimeline__item itineraryTimeline__item--station",
      },
      [
        _c("span", [_c("small", [_vm._v("12:04")])]),
        _vm._v(" "),
        _c("small", [_vm._v("Warszawa Wschodnia")]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "li",
      {
        staticClass:
          "itineraryTimeline__item itineraryTimeline__item--change-start",
      },
      [
        _c("span", [
          _vm._v("\n                  6:48\n                  "),
          _c("small", [_vm._v("3 lut")]),
        ]),
        _vm._v("\n        Warszawa Centralna\n        "),
        _c("small", [_vm._v("peron III, tor 4")]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "li",
      {
        staticClass: "itineraryTimeline__item itineraryTimeline__item--change",
      },
      [
        _c("span", [
          _c("img", { attrs: { src: "/images/pin-change.svg", alt: "" } }),
        ]),
        _vm._v(" "),
        _c("small", [
          _vm._v("czas oczekiwania na stacji Koluszki wynosi 15 min."),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "li",
      {
        staticClass:
          "itineraryTimeline__item itineraryTimeline__item--change-end",
      },
      [
        _c("span", [
          _vm._v("\n                  6:48\n                  "),
          _c("small", [_vm._v("3 lut")]),
        ]),
        _vm._v("\n        Warszawa Centralna\n        "),
        _c("small", [_vm._v("peron III, tor 4")]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "li",
      { staticClass: "itineraryTimeline__item itineraryTimeline__item--end" },
      [
        _c("span", [
          _vm._v("\n                  16:48\n                  "),
          _c("small", [_vm._v("3 lut")]),
        ]),
        _vm._v("\n        Kielce\n      "),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }